import React, { useRef } from 'react'
import propTypes from 'prop-types'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'
import { useBp } from '../../../utils/Breakpoints/Breakpoints'

import './Menu.scss'

const Menu = ({ children, trigger, scope }) => {
  gsap.registerPlugin(useGSAP)

  const tlMenuNav = useRef()
  const tlSubNav = useRef()

  const { name } = trigger
  const { ref: scopeRef, class: scopeClass } = scope

  const belowMd = useBp('< md')
  const duration = 0.15
  const fixed = !belowMd

  const currentRef = (n) => {
    let theRef

    switch (n) {
      case 'subNav':
        theRef = tlSubNav
        break
      case 'menuNav':
        theRef = tlMenuNav
        break
    }
    return theRef
  }

  useGSAP(
    () => {
      if (belowMd) {
        currentRef(name).current = gsap
          .timeline({
            delay: 0,
            defaults: { duration: duration, ease: 'power1.inOut' },
          })
          .from(`${scopeClass} .menu > *`, { opacity: 0 })
          .to(`${scopeClass} .menu`, { marginTop: 8 }, '<')
          .from(
            `${scopeClass} .menu`,
            {
              height: 0,
              opacity: 0,
            },
            '<'
          )
      }
    },
    { dependencies: [belowMd], scope: scopeRef.current, revertOnUpdate: true }
  )

  useGSAP(
    () => {
      if (belowMd && currentRef(name).current) {
        currentRef(name).current.reversed(!trigger.value)
      }
    },
    {
      dependencies: [trigger.value, belowMd],
      scope: scopeRef.current,
      revertOnUpdate: true,
    }
  )

  return <div className={`menu ${fixed ? 'fixed' : ''}`}>{children}</div>
}

Menu.propTypes = {
  children: propTypes.array.isRequired,
  trigger: propTypes.shape(),
  scope: propTypes.shape(),
}

export default Menu
